import React, { FC } from 'react';
import { graphql } from 'gatsby';

import ContactComponent from 'layout/ContactComponent';

import { ContactPageProps } from './models';

const ContactPage: FC<ContactPageProps> = ({ data: { contactPage } }) => (
  <ContactComponent node={contactPage} />
);

export const query = graphql`
  query ($url: String) {
    contactPage(url: { eq: $url }) {
      seoMetaTitle
      seoMetaKeywords
      seoMetaDescription
      url
      title
      body
    }
  }
`;

export default ContactPage;
